import * as React from 'react';
import * as _ from 'lodash';
import $ from 'jquery';
export default function () {
    return React.createElement('div', {}, React.createElement('div', { 'className': 'fab-flex-container' }, React.createElement('div', { 'className': 'fab-logo-upload-outter' }, React.createElement('h1', {}, 'Upload your Company Logo'), React.createElement('div', {
        'className': 'fab-logo-upload-inner',
        'style': this.state.imageUrl ? { backgroundImage: `url(${ this.state.imageUrl })` } : {},
        'onClick': e => {
            e.preventDefault();
            e.stopPropagation();
            $(this.fileUploadNode).click();
        }
    }, React.createElement('input', {
        'type': 'file',
        'className': 'invisible',
        'onClick': e => {
            e.stopPropagation();
        },
        'onChange': this.handleFileSelect,
        'ref': node => {
            this.fileUploadNode = node;
        }
    }))), React.createElement('div', { 'className': 'fab-flex-wrapper' }, React.createElement('div', { 'className': 'fab-col fab-col1' }, React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Fabricator Name'), React.createElement('input', {
        'id': 'name',
        'value': this.state.name,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Phone Number'), React.createElement('input', {
        'id': 'phone',
        'value': this.state.phone,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Email'), React.createElement('input', {
        'id': 'contactEmail',
        'value': this.state.contactEmail,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Redirect URL to your Company Website'), React.createElement('input', {
        'id': 'websiteUrl',
        'value': this.state.websiteUrl,
        'onChange': this.updateFieldValue
    }))), React.createElement('div', { 'className': 'fab-col fab-col2' }, React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Address 1'), React.createElement('input', {
        'id': 'address1',
        'value': this.state.address1,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper' }, React.createElement('h2', {}, 'Address 2'), React.createElement('input', {
        'id': 'address2',
        'value': this.state.address2,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper fab-text-box-wrapper-tunning fab-text-box-wrapper-city' }, React.createElement('h2', {}, 'City'), React.createElement('input', {
        'id': 'city',
        'value': this.state.city,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper fab-text-box-wrapper-tunning fab-text-box-wrapper-state' }, React.createElement('h2', {}, 'State'), React.createElement('input', {
        'id': 'provence',
        'value': this.state.provence,
        'onChange': this.updateFieldValue
    })), React.createElement('div', { 'className': 'fab-text-box-wrapper fab-text-box-wrapper-zip' }, React.createElement('h2', {}, 'Zip'), React.createElement('input', {
        'id': 'postal',
        'value': this.state.postal,
        'onChange': this.updateFieldValue
    })), React.createElement('div', {}, React.createElement('div', {
        'className': 'fab-button',
        'onClick': this.props.authGoogleCalendar
    }, 'Link to Google Calendar'))))));
}